module.exports = __webpack_public_path__ + "img/broadway-travel-logo-web.dacb8597.png";